<template>
<div>
  <MainNavBar />
  <Hero :hero="heroTrinpod" />
  <SectionIntelligentPDF /> 
  <Section :content="filesAndDocs" />
  <Section :content="systemsDigitalTwin" />
  <Section :content="spaceTime" />
  <Section :content="conceptualAwareness" /> 
  <Section :content="docsTwinLinking" />
  <SectionBigData />
  <!--section-trinpod />
  <section-digital-twin />
  <section-own-your-data />
  <Section :content="noSilos" />
  <section-supply-chain-collab />
  <Section :content="hypergraph" />
  <Section :content="helloTrinity" /-->
  <CallToAction :content="trinpodCTA" />
  <GmxFooter />
</div>
</template>

<script>
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import SectionIntelligentPDF from '@/components/section-intelligent-pdf.vue';
import SectionTrinpod from '@/components/section-trinpod.vue';
import SectionBigData from '@/components/section-big-data.vue';
//import SectionDigitalTwin from '../components/section-digital-twin.vue';
import SectionOwnYourData from '@/components/section-own-your-data.vue';
import SectionSupplyChainCollab from '@/components/section-supply-chain-collab.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
import * as log from 'loglevel';
export default {
  name: "TrinPod",
  components: {
    MainNavBar,
    Hero,
    Section,
    SectionIntelligentPDF,
    SectionTrinpod,
    SectionBigData,
    //SectionDigitalTwin,
    SectionOwnYourData,
    SectionSupplyChainCollab,
    CallToAction,
    GmxFooter
  },
  data() {
    return {
      heroTrinpod: { 
        eyebrow: 'The world\'s first conceptually indexed space-time systems digital twin',
        header: 'TrinPod\u2122',
        subheader: 'A TrinPod\u2122 models the complete space-time of part of the world linking systems to documents about those systems. When information is requested by an app, a human-based data structure is read into the server\'s conceptual awareness with real-time inference.',
        img: '',
        videoId: '892755542',
        buttons: [
          { label: 'intelligentPDF\u2122', path: '', id: 'intelligent-pdf' },
          { label: 'Files and Docs', path: '', id: 'files-and-docs' },
          { label: 'Digital Twin', path: '', id: 'systems-digital-twin' },
          { label: 'Docs \u21C4 Twin', path: '', id: 'docs-twin-linking' },
          { label: 'Space-Time', path: '', id: 'space-time' },
          { label: 'Awareness', path: '', id: 'conceptual-awareness' },
          { label: 'Big Data', path: '', id: 'big-data' },
        ]
      },
      filesAndDocs: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Files and Documents',
        paragraphs: [
          'The TrinPod\u2122 contains a complete Documents and Files management system similar to Box or Sharepoint, but with Crosslink creating IntelligentPDF\u2122 and the connection to the Systems Digital Twin it becomes easy to find the information you need from a vast amount of documents, and as the information is stored systematically as Units-of-Thought, linking to the Digital Twin side connects the Digital Twin side to the document information. '
        ],
        id: 'files-and-docs',
        image: 'Documents IntelligentPDF_  RFI-crop.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      systemsDigitalTwin: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Systems Digital Twin',
        paragraphs: [
          'Each TrinPod\u2122 supports a Systems Digital Twin of any part of the world that is quickly created using specs with just a handfull of predicates and relations. Information from sensors or other sources connect to the Digital Twin as Events that change the States of Entities in Space-Time.'
        ],
        id: 'systems-digital-twin',
        image: 'form-follows-function.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      spaceTime: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Space-Time',
        paragraphs: [
          'The TrinPod\u2122 is a fully integrated Events system that captures all Events in Space-Time giving a full history of everything.'
        ],
        id: 'space-time',
        image: 'hypergraph-example.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      conceptualAwareness: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Conceptual Awareness',
        paragraphs: [
          'Our patent pending Linked Data Hypergraph data model powered by our conceptual AI allows the world\'s first full space-time modeling of systems in a single data environment, enabling global collaboration, design, automation, simulation, monitoring and control of real-world systems at any scale.'
        ],
        id: 'conceptual-awareness',
        image: 'conceptual-ai.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      docsTwinLinking: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Documents \u21C4 Twin',
        paragraphs: [
          'Link from any part of the Digital Twin to all information about it on the Document side, and back.' +
          'The TrinPod\u2122 contains both the Digital Twin and the Documents side in one integrated system. All data, including all entities in the Digital Twin has a unique unchanging URL. Place QR-codes to be on any part of a physical system that opens that part in the Digital Twin, including the data and documents about it.'
        ],
        id: 'docs-twin-linking',
        image: 'documents-linked-to-twin.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      noSilos: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Apps no longer create Data Silos',
        paragraphs: [],
        id: 'no-silos',
        image: 'linked_pods.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        html: 
          '<div>' + 
          ' <h5 class="mb-4">Normally, every application you use creates its own data silo. The data is stuck in the app and does not communicate well with other apps.' + 
          ' <h5 class="mb-4">With TrinPod\u2122 you get the opposite. The TrinPod\u2122 is the master of all your data, and you grant the apps read and write access to the data. </h5>' + 
          ' <h5 class="mb-4>No more duplication of data, no apps \"holding\" your data hostage and no more data silos.</h5>' + 
          '</div>',
        learnMoreLink: ''
      },
      hypergraph: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Not just a graph, but a Hypergraph with Event Ontology',
        paragraphs: [],
        id: 'hypergraph-with-event-ontology',
        image: 'trinapp-oneworld_properties.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        html: 
          '<div>' + 
          ' <h5 class="mb-4">Graphs are great for handling the infinite relations of the real world, but they do not handle space time without complex layers.' + 
          ' <h5 class="mb-4">That is why we invented a (patent pending) hypergraph that, together with our event ontology, tracks space time in one graph without complicated layers.</h5>' + 
          '</div>',
        learnMoreLink: ''
      },
      helloTrinity: { 
        eyebrow: 'Trinity',
        eyebrowIcon: '',
        headline: 'Say hello to Trinity, the world\'s first Conceptual AI',
        paragraphs: [
          'Every TrinPod\u2122 comes with Trinity. Trinity is currently working behind the scenes in all our apps including Reading and Crosslinking documents to create IntelligentPDF\u2122. She is designed for our future applications, to do what today requires human time.'
        ],
        id: 'hypergraph-with-event-ontology',
        image: 'trinity-read-pdfs.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-neon-blue-grad',
        /*html: 
          '<div>' + 
          ' <h5 class="mb-4">Every TrinPod\u2122 comes with Trinity. Trinity is the world\'s first AI that can understand conceptually.</h5>' + 
          ' <h5 class="mb-4">Trinity works behind the scenes in all our apps, including Reading and Crosslinking documents, to create IntelligentPDF\u2122. Trinity is the foundation of our future applications, doing what requires human\'s time.</h5>' + 
          '</div>',*/
        learnMoreLink: '/intelligent-pdf'
      },
      trinpodCTA: {
        header: 'Contact us for more information',
        bgClass: 'bg-light-grad text-dark',
        btnText: 'Get more info',
        btnVariant: 'neon-blue'
      }
    }
  },
  methods: {
    img: function (image) {
      require(image)
    },
    scrollToTop: function () {
      window.scrollTo(0,0);
    }
  }
}
</script>

